import styled from '@emotion/styled';

export const LabelContentWrapper = styled.div`
  display: flex;
  gap: ${({theme}) => theme.gap.desktop.lg};
`;

type TextWrapperProps = {
  isFullWidth?: boolean;
};

export const TextWrapper = styled.div`
  ${({isFullWidth}: TextWrapperProps) => isFullWidth === true && `flex: 1`}
`;
